import Swal, {SweetAlertResult,  SweetAlertType} from "sweetalert2";
import i18n from "@/plugins/i18n";
import store from '@/store/'
import {cutErrors, declOfWords, declOfForPasswordLength} from "./notify-utils";

export function notifyError(error?:any, errors?: any, errorText?: string): void {
    let type: SweetAlertType = 'error';
    let message = '';
    let errorMessage = error?.response?.data?.message;
    let errorContext = error?.response?.data?.errorContext || error?.response?.data?.error_context;
    switch (error?.response?.status) {
        case 400:
            if (error?.response?.data){
                let errorCode = parseInt(error.response.data.code || error.response.data.error_code || 0)
                if (errorCode === 1) {
                    if (error.response.data.description.includes('Multiple representations of the same entity')) {
                        message += `<br>${i18n.tc('rule_must_be_unique')}`;
                        break;
                    }
                    message += `<br>${i18n.tc('errors.internal')}`
                } else if (errorCode === 2) {
                    switch (errorMessage) {
                        case '\'mcc\' length must be 2 or 3':
                            message += i18n.t('errors.invalid_length_field', { field: 'MCC' });
                            break;
                        case '\'mnc\' length must be 2 or 3':
                            message += i18n.t('errors.invalid_length_field', { field: 'MNC' });
                            break;
                        default:
                            message += `<br>${i18n.tc('errors.validation')}`
                    }
                } else if (errorCode === 3) {
                    if (errorMessage.includes('Category not deleted')){
                        message+=`<br>${i18n.tc('errors.category_not_deleted')}`
                    }else if(errorMessage.includes('Changes cannot be applied because there are dependent entries')){
                        message+=`<br>${i18n.tc('errors.dependent_transport')}`
                    }else {
                        message+=`<br>${i18n.tc('errors.violation')}`
                    }
                } else if (errorCode === 4) {
                    message += `<br>${i18n.tc('errors.not_found')}`
                } else if (errorCode === 7) {
                    message += `<br>${i18n.tc('errors.incorrect_password')}`
                } else if (errorCode === 8) {
                    message += `<br>${i18n.tc('errors.client_denied_transport')}`
                } else if (errorCode === 9) {
                    message += `<br>${i18n.tc('errors.client_locked')}`
                } else if (errorCode === 10) {
                    message+=`<br>${i18n.tc('errors.main_reserve_filled')}`
                } else if (errorCode === 15) {
                    message+=`<br>${i18n.tc('errors.users_exists_with_this_role')}`
                } else if (errorCode === 16) {
                    let symbols: string = declOfWords(parseInt(errorContext.minimalDifferentSymbolsNumber),"symbols");
                    message = `${i18n.tc("errors.password_difference_symbols")} ${errorContext.minimalDifferentSymbolsNumber} ${symbols}`;
                } else if (errorCode === 17) {
                    let symbols: string = declOfForPasswordLength(parseInt(errorContext.minimalPasswordLength));
                    message = `${i18n.tc("errors.password_length")} ${errorContext.minimalPasswordLength} ${symbols}`;
                } else if (errorCode === 20) {
                    message += `<br>${i18n.tc('errors.overlapping_conditions')}`
                } else if (errorCode === 22) {
                    message += `<br>${i18n.tc('errors.overlapping_conditions')}`
                } else if (errorCode === 23) {
                    message += `<br>${i18n.tc('errors.transport_not_allowed_for_client')}`
                } else if (errorCode === 24) {
                    message += `<br>${i18n.tc('errors.transport_cascading_not_allowed_for_client')}`
                } else if (errorCode === 25) {
                    message += `<br>${i18n.tc('errors.unable_remove_default_user')}`
                } else if (errorCode === 26) {
                    message += `<br>${i18n.tc('errors.unable_change_default_user')}`
                } else if (errorCode === 29) {
                    message += `<br>${i18n.tc('errors.have_not_permission_for_this_user')}`
                } else if (errorCode === 30) {
                    message += `<br>${i18n.tc('errors.unable_remove_default_role')}`
                } else if (errorCode === 31) {
                    message += `<br>${i18n.tc('errors.unable_change_default_role')}`
                } else if (errorCode === 32) {
                    type = 'warning'
                    message += `<br>${i18n.tc('errors.no_data_to_export')}`
                } else if (errorCode === 33) {
                    message += `<br>${i18n.tc('errors.duplicate_preprocessing_rule')}`
                } else if (errorCode === 34) {
                    message += `<br>${i18n.tc('errors.template_with_used_active_bulk')}`
                } else if (errorCode === 35) {
                    message += `<br>${i18n.tc('errors.unable_to_reset_category_transport')} ${errorContext.providers}`
                } else if (errorCode === 36) {
                    message += `<br>${i18n.tc('errors.have_users_with_this_role')}`
                } else if (errorCode === 37) {
                    message += `<br>${i18n.tc('errors.tariff_zones_of_the_group_not_empty')}`
                } else if (errorCode === 39) {
                    message += `<br>${i18n.t('errors.system_setting_not_specified',{ name: errorContext.setting })}`
                } else if (errorCode === 40) {
                    message += `<br>${i18n.tc('errors.duplicate_template_name')}`
                } else if (errorCode === 41) {
                    message += `<br>${i18n.tc('errors.unable_set_ad_group')}`
                } else if (errorCode === 43) {
                    message += `<br>${i18n.tc('errors.unable_save_contact')}`
                } else if (errorCode === 44) {
                    message += `<br>${i18n.t('errors.unable_save_template',{templateID: errorContext.templateID, transport: errorContext.transport})}`
                } else if (errorCode === 45) {
                    message += `<br>${i18n.tc('errors.unable_edit_template')}`
                } else if (errorCode === 46) {
                    message += `<br>${i18n.tc('errors.invalid_distribution_status')}`
                } else if (errorCode === 49) {
                    message += `<br>${i18n.tc('errors.import_file_too_long')}`
                } else if (errorCode === 50) {
                    message += `<br>${i18n.tc('errors.no_partner_user_found')}`
                } else if (errorCode === 51) {
                    message += `<br>${i18n.tc('errors.change_password_limit')}`
                } else if (errorCode === 52) {
                    message += `<br>${i18n.tc('errors.invalid_import_file')}`
                } else if (errorCode === 53) {
                    message += `<br>${i18n.tc('errors.regular_expression_not_allowed')}`
                } else if (errorCode === 54) {
                    message += `<br>${i18n.tc('errors.public_private_key_not_valid')}`
                } else if (errorCode === 301) {
                    message += `<br>${i18n.tc('errors.syntax_error')}`
                } else if (errorCode === 302) {
                    let params = []
                    if (errorContext?.parameter_name) {
                        params = errorContext?.parameter_name.map((item: string) => {
                            if (item == 'group_by') return i18n.tc('group_by') + '/' + i18n.tc('group_by_optionally')
                            return i18n.tc(item)
                        })
                    }
                    message += `<br>${i18n.tc('errors.unable_data')} <br> ${params.join(', ')}`
                } else if (errorCode === 303) {
                    message += `<br>${i18n.tc('errors.invalid_date_format')}`
                } else if (errorCode === 304) {
                    message += `<br>${i18n.tc('errors.invalid_date_interval')}`
                } else if (errorCode === 308) {
                    message += `<br>${i18n.tc('errors.transport_not_allowed')}`
                } else if (errorCode === 309) {
                    type = 'warning'
                    message += `<br>${i18n.tc('errors.no_data_to_export')}`
                } else {
                    for (let errorProp in error.response.data) {
                        message += `<br><b>${errorProp}:</b> ${error.response.data[errorProp]}`
                    }
                }
            }
            break;
        case 401:
            message += `<br>${i18n.tc('errors.unauthorized')}`
            break;
        case 403:
            message += `<br>${i18n.tc('errors.forbidden')}`
            break;
        case 502:
            message += `<br>${i18n.tc('errors.server_unavailable')}`
            break;
    }
    // if (error && !message) {
    //     message = error?.response?.data?.status + ' ' + error?.response?.data?.error
    // }
    if (errors) {
        errors = cutErrors(errors); // TODO: после исправления повторений в валидационных сообщениях - эту штуку можно убрать
        for (let errorIndex in errors) {
            if (errors[errorIndex].length)
                message += `<br>${errors[errorIndex]}`
        }
    }
    if (errorText) {
        message += `<br>${errorText}`
    }
    Swal.fire({
        type: type,
        title: i18n.tc(`dialog.${type}`),
        html: message,
        confirmButtonClass: "md-button md-success button_confirm",
        confirmButtonText: i18n.tc('confirm'),
        showConfirmButton: true
    });
}

export function notifyErrorCustom(message?: string): void {
    message = message ?? i18n.tc('dialog.success');
    Swal.fire({
        type: 'error',
        title: i18n.tc('dialog.error'),
        html: message,
        confirmButtonClass: "md-button md-success button_confirm",
        confirmButtonText: i18n.tc('confirm'),
        showConfirmButton: true
    });
}

export function notifySuccess(message?: string): void {
    message = message ?? i18n.tc('dialog.success');
    Swal.fire({
        type: 'success',
        title: "",
        html: message,
        confirmButtonClass: "md-button md-success button_confirm",
        confirmButtonText: i18n.tc('confirm'),
        showConfirmButton: true
    });
}

export function notifyConfirm(isChange: boolean, action: any, next: any) {
    if (!isChange) {
        next()
    } else {
        if (store.getters.isAuthenticated) {
            Swal.fire({
                type: "warning",
                title: i18n.tc('dialog.warning'),
                html: i18n.tc('dialog.confirm'),
                showCancelButton: true,
                confirmButtonClass: "md-button md-primary button_confirm",
                cancelButtonClass: "md-button",
                confirmButtonText: i18n.tc('values.active.yes'),
                cancelButtonText: i18n.tc('values.active.no'),
                buttonsStyling: false,
                allowOutsideClick: false,
            }).then(result => {
                if (result.dismiss == Swal.DismissReason.esc) {
                    return next(false)
                }
                if (result.value) {
                    action().then(() => {
                        next()
                    })
                } else {
                    next()
                }
            });
        } else {
            next()
        }
    }
}

export async function notifyDelete(message?: string): Promise<boolean> {
    message = message ?? i18n.tc('dialog.delete');
    let result: SweetAlertResult = await Swal.fire({
        type: "warning",
        title: i18n.tc('dialog.warning'),
        html: message,
        showCancelButton: true,
        confirmButtonClass: "md-button md-primary button_confirm",
        cancelButtonClass: "md-button",
        confirmButtonText: i18n.tc('values.active.yes'),
        cancelButtonText: i18n.tc('values.active.no'),
        buttonsStyling: false
    });
    return result.value;
}

export function notifyWarning(message?: string): void {
    message = message ?? i18n.tc('errors.no_data_to_show').toString()
    Swal.fire({
        type: 'warning',
        title: i18n.tc(`dialog.warning`),
        html: message,
        confirmButtonClass: "md-button md-success button_confirm",
        confirmButtonText: i18n.tc('confirm'),
        showConfirmButton: true
    });
}
